export default __webpack_public_path__ + "static/media/insights.97c788be.svg";